import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { Observable } from 'rxjs'
import { PermissionsService } from '../permissions.service'

export const canActivateWhatsappCallLogs: CanActivateFn =
  (): Observable<boolean> => {
    return inject(PermissionsService).hasWhatsappCallLogsAccess$
  }
